import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

// Version 3.2 is the only campaign page (31 Oct 2026, owner). The old address /campaigns-v2/:id stays only because emails, notifications and Taskly tasks
// already sent still carry it: it opens the same campaign on 3.2.
export function CampaignV2Redirect() {
  const { id } = useParams();
  return <Navigate to={`/campaigns-v32/${id}`} replace />;
}
